import React from 'react';

function Card() {
  return (
    <svg
      width="15"
      height="18"
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.32788"
        y="1.21289"
        width="12.6882"
        height="16"
        rx="2.5"
        stroke="currentColor"
      />
    </svg>
  );
}

export default Card;
